import {createFragmentContainer, graphql} from 'react-relay';

const TotalsLoader = ({relay, viewer, children, ...props}) => {
	const formatData = () => {
		return [
			{
				currency: viewer.company.currency,
				financialNumbers: {
					...viewer.company.financialNumbers,
				},
			},
		];
	};
	return children({data: {rows: formatData()}, ...props});
};

export const totalsLoaderQuery = graphql`
	query TotalsLoader_Query(
		$startYear: Int!
		$startMonth: Int!
		$startDay: Int!
		$endYear: Int!
		$endMonth: Int!
		$endDay: Int!
		$searchQuery: TaskSearchQueryType!
	) {
		viewer {
			actualPersonId
			component(name: "project_portfolio_period_totals_loader")
			...TotalsLoader_viewer
				@arguments(
					searchQuery: $searchQuery
					startYear: $startYear
					startMonth: $startMonth
					startDay: $startDay
					endYear: $endYear
					endMonth: $endMonth
					endDay: $endDay
				)
		}
	}
`;

export default createFragmentContainer(TotalsLoader, {
	viewer: graphql`
		fragment TotalsLoader_viewer on Viewer
		@argumentDefinitions(
			searchQuery: {type: "TaskSearchQueryType!"}
			startYear: {type: "Int!"}
			startMonth: {type: "Int!"}
			startDay: {type: "Int!"}
			endYear: {type: "Int!"}
			endMonth: {type: "Int!"}
			endDay: {type: "Int!"}
		) {
			id
			company {
				currency
				financialNumbers(
					searchQuery: $searchQuery
					startYear: $startYear
					startMonth: $startMonth
					startDay: $startDay
					endYear: $endYear
					endMonth: $endMonth
					endDay: $endDay
				) {
					actualRevenue
					actualCost
					actualProfit
					actualMargin
					plannedRevenue
					plannedCost
					plannedProfit
					plannedMargin
					remainingRevenue
					remainingCost
					remainingProfit
					remainingMargin
					forecastRevenue
					forecastCost
					forecastProfit
					forecastMargin
					baselineRevenue
					baselineCost
					baselineProfit
					baselineMargin
					baselineMinutes
					actualVsPlanRevenue
					actualVsPlanCost
					actualVsPlanProfit
					forecastVsPlanRevenue
					forecastVsPlanCost
					forecastVsPlanProfit
					registeredMinutes
					remainingMinutes
					forecastMinutes
					scopeApprovedMinutes
					scopeTotalMinutes
					allocationMinutes
					invoiced
					paid
					invoicedVsActualRevenue
					retainerPeriodTargetMinutes
					retainerPeriodTargetPrice
					lockedRevenue
					recognitionOpenRevenue
					recognitionForecastRevenue
				}
			}
		}
	`,
});
